import { QueryClientProvider } from '@tanstack/react-query';
import type { FunctionComponent, ReactNode } from 'react';

import { queryClient } from '#modules/api/utils/query-client';

export interface ApiProviderProps {
  readonly children?: ReactNode;
}

export const ApiProvider: FunctionComponent<ApiProviderProps> = (props) => {
  const { children } = props;

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};
